import { render, staticRenderFns } from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=template&id=ee2c9352&scoped=true&"
import script from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=script&lang=js&"
export * from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-loi-nhuan-khach-hang.vue?vue&type=style&index=0&id=ee2c9352&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2c9352",
  null
  
)

export default component.exports